import * as types from './constants';

export const toggleCategoryNode = id => ({
  type: types.TOGGLE_CATEGORY_NODE,
  id
});

export const showAdd = id => ({
  type: types.SHOW_ADD,
  id
});

export const hideAdd = () => ({
  type: types.HIDE_ADD
});
